import React from 'react';

const RecurringEditModal = ({ open, onClose, onEditThis, onEditFollowing, lesson }) => {
  const [option, setOption] = React.useState('this');
  React.useEffect(() => { if (open) setOption('this'); }, [open]);
  if (!open || !lesson) return null;
  return (
    <div className="modal-overlay" style={{ zIndex: 3000 }}>
      <div className="modal-content" style={{ minWidth: 270, background: '#f7f7f8', borderRadius: 12, boxShadow: '0 2px 16px #0002', padding: 20, textAlign: 'center' }}>
        <h3 style={{ fontSize: 17, fontWeight: 600, color: '#181818', marginBottom: 18, marginTop: 0, letterSpacing: 0.1 }}>Edit recurring event</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'flex-start', margin: '0 auto 18px auto', maxWidth: 220 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 15, fontWeight: 500, color: '#222', cursor: 'pointer' }}>
            <input type="radio" checked={option === 'this'} onChange={() => setOption('this')} style={{ accentColor: '#111', width: 18, height: 18, margin: 0 }} />
            This event
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 15, fontWeight: 500, color: '#222', cursor: 'pointer' }}>
            <input type="radio" checked={option === 'following'} onChange={() => setOption('following')} style={{ accentColor: '#111', width: 18, height: 18, margin: 0 }} />
            This and following events
          </label>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 14, marginTop: 8 }}>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#444', fontSize: 15, fontWeight: 500, cursor: 'pointer', padding: '7px 16px', borderRadius: 18 }}>Cancel</button>
          <button
            onClick={() => {
              if (option === 'this') onEditThis();
              else {
                console.log('onEditFollowing called with lesson:', lesson);
                onEditFollowing();
              }
            }}
            style={{ background: '#111', color: '#fff', fontWeight: 600, fontSize: 15, border: 'none', borderRadius: 18, padding: '7px 28px', boxShadow: 'none', cursor: 'pointer' }}
          >OK</button>
        </div>
      </div>
    </div>
  );
};

export default RecurringEditModal;
